/** Every hit carries one, so the stats can be filtered down to real players. */
export enum TrackingEnvironment {
  Localhost = "localhost",
  DeployedDev = "deployed-dev",
  Prod = "prod",
}
